export const rangeTypes = {
  fixed: 'fixed',
  dynamic: 'dynamic',
}
